import {Box, Divider, Stack, Switch, Typography} from '@mui/material';
import {FabricObject} from 'fabric';
import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {useFloorplanContext} from '../hooks/useFloorplanContext';
import TableSettingsSeatPanel from './TableSettingsSeatPanel';

interface Props {
    element: FabricObject;
    onElementUpdated: () => void;
}

export const TableSettingsPanel: React.FC<Props> = ({
                                                        element,
                                                        onElementUpdated,
                                                    }) => {
    const {t} = useTranslation();
    const {updateTableElementLocally} = useFloorplanContext();
    const tableData = element.floorPlanItem!.table!;

    const handleUpdateResourceMeta = useCallback((
        key: 'autoAssignExternally' | 'bookableExternally',
        checked: boolean
    ) => {
        // update the checked state from the table element
        const nextElement = updateTableElementLocally(element, (currentItem) => ({
            ...currentItem,
            table: {
                ...currentItem.table!,

                resource: {
                    ...currentItem.table!.resource,
                    meta: {
                        ...currentItem.table!.resource?.meta,
                        [key]: checked,
                    },
                },
            },
        }));

        if (!nextElement) return;
        onElementUpdated();
    }, [element, onElementUpdated, updateTableElementLocally]);

    return (
        <Box>
            <TableSettingsSeatPanel
                element={element}
                onElementUpdated={onElementUpdated}
            />

            <Divider sx={{my: 2}}/>

            <Stack direction="row" alignItems="center" gap={1}>
                <Switch
                    checked={tableData.resource?.meta?.autoAssignExternally ?? false}
                    onChange={(event) => handleUpdateResourceMeta(
                        'autoAssignExternally',
                        event.target.checked
                    )}
                />
                <Typography variant="body2">
                    {t('Auto assign')}
                </Typography>
            </Stack>

            <Stack direction="row" alignItems="center" gap={1}>
                <Switch
                    checked={tableData.resource?.meta?.bookableExternally ?? false}
                    onChange={(event) => handleUpdateResourceMeta(
                        'bookableExternally',
                        event.target.checked
                    )}
                />
                <Typography variant="body2">
                    {t('Bookable through widget')}
                </Typography>
            </Stack>
        </Box>
    );
};

export default TableSettingsPanel;
